import { absenceIcon, autoMatchingIcon } from 'assets/icons/Notification';

export const NOTIFICATION_TYPE_AUTO_MATCHING = 4;
export const NOTIFICATION_TYPE_ABSENCE = 2;
export const NOTIFICATION_TYPE_REMIND = 6;
export const NOTIFICATION_STATUS_ABSENCE_RESCHEDULE = 12;
export const NOTIFICATION_STATUS_ABSENCE_NOT_RESCHEDULE = 8;
export const NOTIFICATION_TYPES = [
  {
    value: NOTIFICATION_TYPE_AUTO_MATCHING,
    icon: autoMatchingIcon,
  },
  {
    value: NOTIFICATION_TYPE_ABSENCE,
    icon: absenceIcon,
  },
];
